import React from 'react';
import URI from 'urijs';


// This is for the push notes ONLY (All sends to all)
export const GAME_OPTIONS = [
  ['all', 'All'],
  ['lol', 'League of Legends'],
  ['csgo', 'CS:GO'],
  ['ow', 'Overwatch'],
  ['pubg', 'PUBG'],
];

// This is for generic usage.
export const ESPORT_TYPE_OPTIONS = [
  ['', 'None'],
  ['lol', 'League of Legends'],
  ['csgo', 'CS:GO'],
  ['ow', 'Overwatch'],
  ['pubg', 'PUBG'],
];

export const SPOILER_OPTIONS = [
  ['all', 'All'],
  [true, 'On'],
  [false, 'Off'],
];

export const BLITZ_ENTRY_TYPE_OPTIONS = [
  ['article', 'Article'],
  ['youtube', 'Video'],
  ['guide', 'Guide'],
];

export const ENTRY_TYPE_OPTIONS = [
  ['article', 'Article'],
  ['youtube', 'Youtube'],
  ['feed', 'BlitzFeed'],
];

export const ENTRY_TABLE_TYPE_OPTIONS = [
  'article', 'youtube', 'feed',
];

export const SOURCE_TABLE_TYPE_OPTIONS = [
  '', 'rss',
];

export const ESPORT_TABLE_TYPE_OPTIONS = [
  '', 'lol', 'csgo', 'ow', 'pubg'
];

export const SOURCE_TYPE_OPTIONS = [
  ['', 'None'],
  ['rss', 'RSS Feed'],
];

export const CHAT_TYPE_OPTIONS = [
  ['', 'None'],
  ['raffle', 'Raffle'],
  ['entry', 'Entry'],
  ['match', 'Match'],
];

export const EDITOR_IMAGE_OPTIONS = [
  { value: 'regular', label: 'Regular' },
  { value: 'full-width', label: 'Full Width' },
  { value: 'left', label: 'Float Left' },
  { value: 'right', label: 'Float Right' },
];

export const CONVERT_HTML_OPTIONS = {
  blockToHTML: (block) => {
    if (block.type === 'atomic') {
      return <div style={{ clear: 'both' }} />;
    } else if (block.type === 'unstyled' && block.text === '') {
      return {
        start: '',
        end: '',
      };
    } else if (block.type === 'code-block') {
      return block.text;
      // return <div dangerouslySetInnerHTML={{ __html: block.text }} />
    }
    // return <p style={{ clear: 'both' }} />;
  },
  entityToHTML: (entity, originalText) => {
    if (entity.type === 'LINK') {
      // https://github.com/HubSpot/draft-convert/issues/47
      return <a href={entity.data.url} target="_blank" rel="noopener noreferrer" />;
    } else if (entity.type === 'image') {
      const extraClasses = entity.data.extraClasses || '';
      const { src, caption, style, alt, size, width } = entity.data;

      let figureClass;
      switch (style) {
        case 'full-width':
          figureClass = 'figure-full';
          break;
        case 'left':
          figureClass = 'figure-left';
          break;
        case 'right':
          figureClass = 'figure-right';
          break;
        default:
          figureClass = '';
      }

      let cleanedWidth;

      if (width <= 0) {
        cleanedWidth = 0;
      } else if (width && width < 50) {
        cleanedWidth = 50;
      } else {
        cleanedWidth = width;
      }

      return (
        <figure className={`${figureClass} ${extraClasses}`} style={cleanedWidth ? { width: `${cleanedWidth}px` } : {}}>
          <img src={src} alt={alt} data-img-width={size && size.width} data-img-height={size && size.height} />
          {caption && <figcaption>{caption}</figcaption>}
        </figure>
      );
    } else if (entity.type === 'youtube') {
      const { src } = entity.data;
      const urlData = URI(src);
      let v;
      if (urlData.domain() === 'youtu.be') {
        v = urlData.path().slice(1, -1);
      } else if (urlData.domain() === 'youtube.com' && urlData.hasQuery('v')) {
        v = urlData.query(true).v;
      }
      return (
        <figure className="figure-video">
          <iframe
            type="text/html"
            src={`https://www.youtube.com/embed/${v}`}
            frameBorder="0"
            allowFullScreen
          />
        </figure>
      );
    } else if (entity.type === 'tweet') {
      const { tweet } = entity.data;
      // const tweetId = urlList[urlList.length - 1];
      return tweet.html;
    }
    return originalText;
  },
};



// WEBPACK FOOTER //
// ./src/cms/form/constants.js